import {SendEmailVars} from '../../../../../../../util/uiconstants';
import {RECIPIENTS_SELECTED_LIST, RECIPIENT_LIST} from '../utils/constants';

const setUserList = (values) => {
	const userSelection = [];
	const contactList = values[RECIPIENT_LIST];
	const selectedContacts = values[RECIPIENTS_SELECTED_LIST];
	selectedContacts.forEach((x) => {
		let exist = userSelection?.find((j) => j.userId === x);
		if (!exist) {
			let selected = contactList?.find((j) => j.userId === x);
			if (selected) {
				let entities = [];
				selected.entities.forEach((a) => {
					const entity = {id: a.id, label: a.label, name: a.label};
					entities.push(entity);
				});
				selected[SendEmailVars.entities] = entities;
				userSelection.push(selected);
			}
		}
	});
	return userSelection;
};
export default setUserList;